import { t } from '../../../../locale';
import { FlowInterface } from '../flow-interface';
import { generateBuyLink } from '../../helper/utils';
import { planTypes } from '../../constant';

export default class Trial2paid extends FlowInterface {
  getCurrentParams() {
    return {
      ...this.getTrail2PaidParams(),
      subPlan: planTypes.ZOOM_SCHEDULER,
    }
  }

  getLink() {
    return generateBuyLink(this.getCurrentParams());
  }

  getOptions() {
    return {
      disabled: !this.productEntryData?.currentUserHasPermission,
      buttonTitle: t('billing.product.entry_free_trial.upgrade'),
    };
  }
}
